/**
 * Macedonian denar.
 */
export var MKD = {
  code: 'MKD',
  base: 10,
  exponent: 2
};